import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { BookOpenIcon, BrainIcon, MessageSquareIcon, ClockIcon, MapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const features = [{
  icon: BookOpenIcon,
  title: 'The A-Z Symptom Encyclopedia',
  description: 'Comprehensive emotional decoding for over 100+ common physical conditions.'
}, {
  icon: BrainIcon,
  title: 'The Biological Mirror™ Framework',
  description: 'Learn exactly how your brain chooses which organ to "sicken" based on your stress.'
}, {
  icon: MessageSquareIcon,
  title: 'Neurological Release Scripts',
  description: 'Specific spoken affirmations to "signal" safety to your internal organs.'
}, {
  icon: ClockIcon,
  title: 'The 48-Hour Deactivation Guide',
  description: 'What to do immediately after discovering your emotional trigger to accelerate healing.'
}, {
  icon: MapIcon,
  title: 'The Quick-Reference Body Map',
  description: 'A visual guide to understanding the emotional zones of the human body.'
}];
export function WhatYouGet() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="w-full bg-dark-navy-light py-20 px-6 md:px-12" data-id="element-128">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {
      opacity: 0,
      y: 30
    }} transition={{
      duration: 0.8
    }} className="max-w-6xl mx-auto space-y-12" data-id="element-129">
        <h2 className="text-3xl md:text-5xl font-bold text-white text-center" data-id="element-130">
          What You Get
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-131">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 20
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-dark-navy p-6 rounded-lg space-y-4 border border-teal-accent/20 hover:border-teal-accent/40 hover:cyan-glow transition-all" data-id="element-132">
              <div className="w-12 h-12 bg-teal-accent/10 rounded-lg flex items-center justify-center cyan-glow" data-id="element-133">
                <feature.icon className="w-6 h-6 text-teal-accent" data-id="element-134" />
              </div>
              <h3 className="text-xl font-bold text-white" data-id="element-135">{feature.title}</h3>
              <p className="text-stone-400 leading-relaxed" data-id="element-136">
                {feature.description}
              </p>
            </motion.div>)}
        </div>

        <div className="flex justify-center pt-8" data-id="element-137">
          <CTAButton data-id="element-138" />
        </div>
      </motion.div>
    </section>;
}